import { endedByLine } from '../lib/endedParty.js';

import { ModalShell } from './ModalShell.js';
import { pillButton } from './pillButton.js';

import type { ReactElement } from 'react';

type PartyEndedModalProps = {
  readonly partyDisplayName: string;
  /** The DJ who called it, or null when the party simply went quiet. */
  readonly endedBy: string | null;
  readonly onAcknowledge: () => void;
};

export const PartyEndedModal = ({
  partyDisplayName,
  endedBy,
  onAcknowledge,
}: PartyEndedModalProps): ReactElement => (
  <ModalShell
    eyebrow="Party over"
    title={`${partyDisplayName} has ended`}
    onDismiss={onAcknowledge}
  >
    <p className="text-secondary mt-2 text-sm">
      {endedByLine(endedBy)} Spotify is no longer being followed for this party.
    </p>
    <button type="button" onClick={onAcknowledge} className={`${pillButton('solid')} mt-4 w-full`}>
      OK
    </button>
  </ModalShell>
);
